import React from "react";
import { Box } from "@mui/material";
import AppDrawer from "./appDrawer";

const AppHeader = ({ children }) => (
  <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
    <AppDrawer />
    <Box sx={{ ml: { md: 7, xs: 1 }, mr: 1, mt: 5 }}>{children}</Box>
  </Box>
);

export default AppHeader;
